import React from 'react';
import { 
  Container, 
  Row, 
  Col, 
  Card, 
  CardBody, 
  CardHeader,
  Badge
} from "reactstrap";
import MainLayout from "../../layouts/MainLayout";

function AboutPage() {
  return (
    <MainLayout>
      <section className="py-5 bg-light" dir="rtl">
        <Container>
          <Row className="justify-content-center">
            <Col lg="10" md="12">
              <div className="text-center mb-5">
                <h1 className="mb-3">حول <span className="text-primary">مشنص</span></h1>
                <p className="lead text-muted">
                  منصتك العقارية الموثوقة في الكويت
                </p>
              </div>
              
              <Card className="border-0">
                <CardHeader className="bg-primary text-white">
                  <h3 className="mb-0">منصة مشنص للعقارات</h3>
                </CardHeader>
                <CardBody className="p-4">
                  <div className="about-content">

                    <div className="mb-5">
                      <h4 className="text-primary mb-3">من نحن</h4>
                      <p className="text-justify lead">
                        <strong>مشنص</strong> هي منصة عقارية كويتية صُممت من قبل خبراء في المجال العقاري لتكون أداة عملية وسهلة تجمع بين احتياجات المكاتب العقارية والمستخدمين الأفراد.
                      </p>
                      <p className="text-justify">
                        انطلقت فكرة مشنص من تجربة ميدانية حقيقية في السوق الكويتي، حيث لاحظنا كأصحاب مكاتب عقارية أن أغلب التطبيقات الحالية تفتقد إلى بعض الخصائص التي يحتاجها الوسيط والمستثمر والباحث عن العقار. لذلك صممنا منصة بسيطة، دقيقة، وتخدم الطرفين بشكل فعّال.
                      </p>
                    </div>

                    <div className="mb-5">
                      <h4 className="text-primary mb-3">رؤيتنا</h4>
                      <p className="text-justify">
                        أن نصبح الخيار المفضل في الكويت لكل من يبحث عن وسيلة موثوقة وسهلة لإدارة الإعلانات العقارية والتواصل بين البائع والمشتري والمستأجر، عبر تجربة مريحة وواضحة بعيداً عن التعقيد.
                      </p>
                    </div>

                    <div className="mb-5">
                      <h4 className="text-primary mb-3">مهمتنا</h4>
                      <p className="text-justify">
                        تقديم تجربة عقارية متكاملة تدمج بين الخبرة المحلية والتقنية الحديثة، بحيث نوفر للمكاتب العقارية وأصحاب العقارات وسيلة احترافية للإعلان، ونمنح المستخدمين تجربة تصفح وبحث دقيقة تساعدهم على اتخاذ قراراتهم بثقة.
                      </p>
                    </div>

                    <div className="mb-5">
                      <h4 className="text-primary mb-3">كيف تعمل منصة مشنص؟</h4>

                      <Row className="mt-4">
                        <Col md="6" className="mb-4">
                          <Card className="h-100 border-primary">
                            <CardBody className="text-center">
                              <div className="mb-3">
                                <Badge color="primary" className="badge-lg p-3">
                                  <i className="fas fa-home fa-2x"></i>
                                </Badge>
                              </div>
                              <h5 className="text-primary">لأصحاب العقارات والمكاتب</h5>
                              <p className="text-justify">
                                يمكن لأصحاب العقارات والمكاتب إنشاء حساب ونشر إعلانات لعقاراتهم بسهولة، مع إمكانية إضافة الصور والموقع والسعر والتفاصيل الكاملة، وإدارة الإعلانات من لوحة تحكم واضحة وسريعة.
                              </p>
                            </CardBody>
                          </Card>
                        </Col>

                        <Col md="6" className="mb-4">
                          <Card className="h-100 border-success">
                            <CardBody className="text-center">
                              <div className="mb-3">
                                <Badge color="success" className="badge-lg p-3">
                                  <i className="fas fa-search fa-2x"></i>
                                </Badge>
                              </div>
                              <h5 className="text-success">للباحثين عن العقار</h5>
                              <p className="text-justify">
                                يتيح مشنص للمستخدمين تصفح العقارات المتاحة، والبحث بسهولة حسب الموقع والسعر ونوع العقار (بيع – إيجار – بدل)، مع إمكانية التواصل المباشر مع المعلن.
                              </p>
                            </CardBody>
                          </Card>
                        </Col>
                      </Row>
                    </div>

                    <div className="mb-5">
                      <h4 className="text-primary mb-3">خدماتنا</h4>

                      <Row>
                        <Col md="4" className="mb-3">
                          <div className="service-item p-3 bg-light rounded">
                            <h6 className="text-primary mb-2">🏠 بيع العقارات</h6>
                            <p className="small text-justify">عرض وبيع جميع أنواع العقارات السكنية والاستثمارية والتجارية.</p>
                          </div>
                        </Col>

                        <Col md="4" className="mb-3">
                          <div className="service-item p-3 bg-light rounded">
                            <h6 className="text-primary mb-2">🏢 إيجار العقارات</h6>
                            <p className="small text-justify">تسهيل عمليات الإيجار للملاك والمستأجرين.</p>
                          </div>
                        </Col>

                        <Col md="4" className="mb-3">
                          <div className="service-item p-3 bg-light rounded">
                            <h6 className="text-primary mb-2">🔁 البدل</h6>
                            <p className="small text-justify">البدل بين العقارات حسب المتعارف عليه في السوق الكويتي.</p>
                          </div>
                        </Col>

                        <Col md="4" className="mb-3">
                          <div className="service-item p-3 bg-light rounded">
                            <h6 className="text-primary mb-2">📱 تطبيق ذكي</h6>
                            <p className="small text-justify">واجهة سهلة وسريعة التصفح تعمل على جميع الأجهزة.</p>
                          </div>
                        </Col>

                        <Col md="4" className="mb-3">
                          <div className="service-item p-3 bg-light rounded">
                            <h6 className="text-primary mb-2">💬 دعم فني مباشر</h6>
                            <p className="small text-justify">فريق مختص جاهز للرد على الاستفسارات ومتابعة الملاحظات.</p>
                          </div>
                        </Col>
                      </Row>
                    </div>

                    <div className="mb-4">
                      <h4 className="text-primary mb-3">تواصل معنا</h4>
                      <p className="text-justify">
                        نحن دائماً جاهزون لسماع اقتراحاتكم وملاحظاتكم لتطوير المنصة وتحسين التجربة.
                      </p>

                      <div className="contact-info bg-light p-4 rounded">
                        <Row>
                          <Col md="6">
                            <p className="mb-2"><strong>📩 البريد الإلكتروني:</strong> contact@mishnis.net</p>
                            <p className="mb-2"><strong>📞 رقم الهاتف:</strong> <span dir="ltr">+965 50 11 93 33</span> </p>
                          </Col>
                        </Row>
                      </div>
                    </div>

                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>
    </MainLayout>
  );
}

export default AboutPage;